export default __webpack_public_path__ + "static/media/dds5168_4p-1.3569e81c.png";